import { FaFileInvoiceDollar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import {
    BankSlipCard,
    BankSlipHeader,
    BankSlipIcon,
    BankSlipTitle,
    BankSlipInfo,
    BankSlipInfoText,
    BankSlipButton,
    PaymentTitleBox,
    PaymentTitle,
    PaymentSubtitle,
} from './CardBankSlip.style';

import type { CardBankSlipProps } from './CardBankSlip.type';

export const CardBankSlip = ({ onHandleSubmit }: CardBankSlipProps) => {
    const { t } = useTranslation();

    return (
        <BankSlipCard>
            <PaymentTitleBox>
                <PaymentTitle>
                    {t('subscriptionFormPaymentBoxTitle')}
                </PaymentTitle>
                <PaymentSubtitle>
                    {t('subscriptionFormPaymentBoxSubtitle', {
                        number: '+55 (49) 9 9148-1399',
                    })}
                </PaymentSubtitle>
            </PaymentTitleBox>

            <BankSlipHeader>
                <BankSlipIcon>
                    <FaFileInvoiceDollar size={24} />
                </BankSlipIcon>
                <BankSlipTitle>{t('paymentMethodBankSlip')}</BankSlipTitle>
            </BankSlipHeader>

            <BankSlipInfo>
                <BankSlipInfoText>{t('bankSlipPaymentInfo')}</BankSlipInfoText>
            </BankSlipInfo>

            <BankSlipButton type="button" onClick={onHandleSubmit}>
                {t('generateBankSlip')}
            </BankSlipButton>
        </BankSlipCard>
    );
};
